<template>
  <div class="card">
    <div class="card-header text-lg cardExecucoesAtivas">
      <span class="badge badge-warning mr-2">{{
        parseFloat(countExecucaoPreventiva) + parseFloat(countExecucao)
      }}</span>
      {{ $t('Execuções') }}
    </div>

    <div class="card-body ">
      <div class="row align-items-center">
        <div class="col-12 text-center pt-3 animated fadeout" v-if="!iniciadas">
          <span style="font-size: 2rem">
            <i class="fas fa-pulse fa-spinner mr-3"></i>Carregando...
          </span>
        </div>
        <div class="col-12 text-center pt-3 animated fadeout" v-if="iniciadas == '' && iniciadasPreventivas == ''">
          <span style="font-size: 2rem">
            {{ $t('Nenhuma execução ativa') }}.
          </span>
        </div>
        <div class="col-12">
          <div v-for="os in iniciadasPreventivas" :key="os.nr_sequencial" class="bg-collapse" :style="backgroundHora(os)">
            <div class="row align-items-center">
              <div class="col-md-9 col-sm-8">
                <h5>
                  <span class="badge badge-info v-align-top mr-2">{{
                    1
                  }}</span>
                  {{ os.ds_colaborador }}
                </h5>
              </div>
              <div class="col-md-3 col-sm-4 text-right">
                <button class="btn btn-secondary mr-2 btn-sm-block" v-b-toggle="'collapse-' + os.nr_sequencial" @click="
                  visible === os.nr_sequencial ? (visible = null) : (visible = os.nr_sequencial)
                  ">
                  <span v-if="visible !== os.nr_sequencial">
                    <i class="fas fa-plus mr-1"></i>&nbsp; {{ $t('Mostrar') }}
                  </span>
                  <span v-if="visible === os.nr_sequencial">
                    <i class="fas fa-minus mr-1"></i>&nbsp; {{ $t('Esconder') }}
                  </span>
                </button>
              </div>
              <div class="col-12">
                <hr />
              </div>
            </div>

            <b-collapse class="row" :id="'collapse-' + os.nr_sequencial" accordion="accordionColaboradoes">
              <!-- <div class="col-12" v-for="(execucao, indexE) in tecnico.execucoes_iniciadas" :key="indexE"> -->
              <div class="card" style="width: 100%;">
                <div class="card-body bg_light">
                  <execucao-ativa-preventiva :execucao="os">
                  </execucao-ativa-preventiva>
                </div>
              </div>
              <!-- </div> -->
            </b-collapse>
          </div>
        </div>
        <div class="col-12" v-if="iniciadas">
          <div v-for="(tecnico, index) in iniciadas" :key="index" class="bg-collapse" :style="backgroundHora(tecnico)">
            <div class="row align-items-center">
              <div class="col-md-9 col-sm-8">
                <h5>
                  <span class="badge badge-info v-align-top mr-2">{{
                    1
                  }}</span>
                  {{ tecnico.ds_colaborador }}
                </h5>
              </div>
              <div class="col-md-3 col-sm-4 text-right">
                <button class="btn btn-secondary mr-2 btn-sm-block" v-b-toggle="'collapse-' + index" @click="
                  visible === index ? (visible = null) : (visible = index)
                  ">
                  <span v-if="visible !== index">
                    <i class="fas fa-plus mr-1"></i>&nbsp; {{ $t('Mostrar') }}
                  </span>
                  <span v-if="visible === index">
                    <i class="fas fa-minus mr-1"></i>&nbsp; {{ $t('Esconder') }}
                  </span>
                </button>
              </div>
              <div class="col-12">
                <hr />
              </div>
            </div>

            <b-collapse class="row" :id="'collapse-' + index" accordion="accordionColaboradoes">
              <!-- <div class="col-12" v-for="(execucao, indexE) in tecnico.execucoes_iniciadas" :key="indexE">
                <div class="card">
                  <div class="card-body bg-light">
                    <execucao-ativa :execucao="execucao" :frotaItems="frotaItems" :exibeParar="mostraParar(tecnico.ds_colaborador)"></execucao-ativa>
                  </div>
                </div>
              </div> -->
              <div class="col-12">
                <div class="card">
                  <div class="card-body bg-light">
                    <execucao-ativa :execucao="tecnico" :frotaItems="frotaItems"
                      :exibeParar="mostraParar(tecnico.ds_colaborador)"></execucao-ativa>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <modal-tecnicos></modal-tecnicos>
  </div>
</template>

<script>
import ExecucaoAtiva from '@/components/ExecucaoAtiva'
import ExecucaoAtivaPreventiva from '@/components/ExecucaoAtivaPreventiva'
import ModalTecnicos from '@/components/ModalTecnicos'

export default {
  components: {
    ExecucaoAtiva,
    ModalTecnicos,
    ExecucaoAtivaPreventiva
  },

  created() {
    const filial = this.$store.getters['filial/filial']
    const data = {
      nr_seq_filial: filial.nr_sequencial
    }
    this.$store.dispatch('osItemExecucao/fetchIniciadasFromApi', { data: data })
  },

  data() {
    return {
      visible: null,
      nameMecanico: '',
      numExecucao: 0
    }
  },

  computed: {
    // backgroundHora() {
    //   return 'border-color: rgb(29, 156, 20)'
    // },
    filial() {
      return this.$store.getters['filial/filial']
    },
    frotaItems() {
      const items = this.$store.getters['frotaItem/items']

      if (!items && this.filial) {
        this.$store.dispatch('frotaItem/fetchFromApi', {
          params: {
            filial: this.filial.nr_sequencial, estoque: true
          }
        })
        return []
      }
      return items
    },

    iniciadas() {
      if (this.$store.getters['osItemExecucao/iniciadas']) {

        // this.totExecucao(this.$store.getters['osItemExecucao/iniciadas'])
      }

      return this.$store.getters['osItemExecucao/iniciadas']
    },

    iniciadasPreventivas() {
      return this.$store.getters['osItemExecucao/iniciadasPreventivas']
    },

    countExecucao() {
      return this.$store.getters['osItemExecucao/totalIniciadas']
    },

    countExecucaoPreventiva() {
      return this.$store.getters['osItemExecucao/totalIniciadasPreventivas']
    },

    // execucaoData() {
    //   return this.$store.getters['osItemExecucao/data']
    // }
  },

  methods: {
    dataAtualFormatada(){
        var data = new Date(),
            dia  = data.getDate().toString(),
            diaF = (dia.length == 1) ? '0'+dia : dia,
            mes  = (data.getMonth()+1).toString(), //+1 pois no getMonth Janeiro começa com zero.
            mesF = (mes.length == 1) ? '0'+mes : mes,
            anoF = data.getFullYear();
        return anoF+"/"+mesF+"/"+diaF;
    },
    somarDataAtualMaisSla(tecnico){
      const dataSla = new Date(tecnico.dt_inicio)
      const horaSla = new Date(`${this.dataAtualFormatada()} ${tecnico.hr_sla}`)

      var hora1 = { 
        horas: dataSla.getHours(), 
        minutos: dataSla.getMinutes(), 
        segundos: dataSla.getSeconds()
       };

      var hora2 = { 
        horas: horaSla.getHours(), 
        minutos: horaSla.getMinutes(), 
        segundos: horaSla.getSeconds()
       };

      var somaHoras = {
        horas: hora1.horas + hora2.horas,
        minutos: hora1.minutos + hora2.minutos,
        segundos: hora1.segundos + hora2.segundos
      };

      // Verifique se os segundos excedem 60 e faça os ajustes necessários
      if (somaHoras.segundos >= 60) {
        somaHoras.minutos += Math.floor(somaHoras.segundos / 60);
        somaHoras.segundos = somaHoras.segundos % 60;
      }

      // Verifique se os minutos excedem 60 e faça os ajustes necessários
      if (somaHoras.minutos >= 60) {
        somaHoras.horas += Math.floor(somaHoras.minutos / 60);
        somaHoras.minutos = somaHoras.minutos % 60;
      }

      return new Date(`${this.dataAtualFormatada()} ${somaHoras.horas}:${somaHoras.minutos}:${somaHoras.segundos}`)
    },
    backgroundHora(tecnico) {
      const dataAtual = new Date()
      const somaHoraSla = this.somarDataAtualMaisSla(tecnico)

      // console.log(dataAtual)
      // console.log(somaHoraSla)

      if(dataAtual < somaHoraSla) {
        return 'border-color: #1d9c14'
      } else {
        return 'border-color: #a80b1a'
      }
    },
    mostraParar(tecnico) {
      let mecanicoOs = JSON.parse(localStorage.filial)
      if (mecanicoOs.atendeOs === 'S') {
        if (tecnico == mecanicoOs.dsColaborador) {

          return true
        }

        return false
      }

      return true
    },
    totExecucao(response) {
      let mecanicoOs = JSON.parse(localStorage.filial)
      if (mecanicoOs.atendeOs == 'S') {
        for (let i = 0; i <= response.length; i++) {
          if (response[i] != undefined) {
            if (mecanicoOs.dsColaborador == response[i].ds_colaborador) {
              this.numExecucao = response[i].execucoes_iniciadas.length
            }
          }
        }
      } else {
        this.numExecucao = this.countExecucao
      }
    }
  }
}
</script>
<style scoped>
.cardExecucoesAtivas {
  background: #267f26;
  border-radius: 25px !important;
  color: #fff;
}
.bg-collapse{
  border: 2px solid;
  border-bottom: 6px solid;
  border-left: 6px solid;
  border-radius: 20px;
  margin: 5px;
  padding: 12px;
  border-top-left-radius: 25px;
}
</style>